import { render, staticRenderFns } from "./AddressInfo.vue?vue&type=template&id=48be5b52&scoped=true"
import script from "./AddressInfo.vue?vue&type=script&lang=js"
export * from "./AddressInfo.vue?vue&type=script&lang=js"
import style0 from "./AddressInfo.vue?vue&type=style&index=0&id=48be5b52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be5b52",
  null
  
)

export default component.exports